import React, { useMemo, useState } from "react";
import SectionTitleAndDescription from "./SectionTitleAndDescription";
import Label from "components/Common/Label/Label";
import SearchFilterDropdown from "components/Common/SearchableDropdown/SearchFilterDropdown";
import { fetchUserList, UserValue } from "components/Common/SearchableHiringCompany/SearchableHiringCompany";
import debounce from "lodash/debounce";
import { useDispatch } from "react-redux";


interface AgencySelectProps {
    title: string;
    labelTitle: string;
    dispatchAddAction: any;
    dispatchRemoveAction: any;
    industryData: any;
    // isIncludeCompany: boolean;
    // setIsIncludeCompany: any;
    // selectedCompanies: Company[];
    // dispatchGroupSelect: any;
}

const AgencyCompanies: React.FC<AgencySelectProps> = ({ title, labelTitle, dispatchAddAction, dispatchRemoveAction, industryData }) => {
    const [options, setOptions] = useState<UserValue[]>([]);
    const [fetching, setFetching] = useState(false);
    const dispatch = useDispatch();


    const debounceFetcher = useMemo(() => {
        const loadOptions = (value: string) => {
            setFetching(true);
            fetchUserList(value).then((newOptions) => {
                setOptions(newOptions);
                setFetching(false);
            });
        };

        return debounce(loadOptions, 800);
    }, []);

    // Handle input change and trigger the debounce fetcher
    const handleInputChange = (value: string) => {
        debounceFetcher(value);
    };

    const handleSelect = (value: any) => {
        const lastValue = value[value.length - 1];
        dispatch(dispatchAddAction(lastValue));
    };

    const handleDeselect = (value: any) => {
        dispatch(dispatchRemoveAction(value));
    };

    return (
        <div className="mb-10">
            <SectionTitleAndDescription title={title} isRequiredSection={false} isHelpInfoReq={false} />
            <div className="flex flex-col border-2 rounded-lg border-main-border border-dashed p-7">
                <div className="xl:flex grid xl:gap-12 gap-5 pb-4 items-center">
                    <div className="w-full">
                        <Label labelTitle={labelTitle} isHelpIconRequired tooltipText={"This is a tooltip"} />
                        <div className="mt-1.5 SelectProject-input">
                            <SearchFilterDropdown
                                mode="multiple"
                                options={options}
                                onInputChange={handleInputChange}
                                onChange={handleSelect}
                                defaultValue={industryData}
                                handleDeselect={handleDeselect}
                                placeholder="Start company name typing..."
                                loading={fetching}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgencyCompanies;